export default {
  message: {
    "error": "Oups ! Un problème est survenu.",
    "Sorrysomeerrorsoccurred": "Une erreur inattendue s'est produite. Vous pouvez essayer de changer de langue ou de quitter et redémarrer l'application.",
    "quit": "Quitter",
    "language": "Langue",
    "Youcanchangethelanguagehere": "Vous pouvez changer la langue ici!",
    "current": "Actuel",
    "home": "Accueil",
    "friends": "Amis",
    "wallet": "Portefeuille",
    "aboutus": "À propos de nous",
    "Sharewithfriends": "Partager avec des amis",
    "copyFailure": "Échec de la copie",
    "copySuccess": "Copie réussie",
    "Claimreward": "Recevoir une récompense",
    "DailyLogin": "Connexion quotidienne",
    "noInvitationsYet": "Aucune invitation pour le moment",
    "LoadMore": "Charger plus",
    "WatchAD": "Regarder de la publicité",
    "continue": "Continuer",
    "Congratulations": "Félicitations",
    "MyFriends": "Mes amis",
    "Invitefriends": "Inviter des amis",
    "Invitepremiumfriends": "Inviter des amis premium",
    "DailyTasks": "Tâches quotidiennes",
    "inviteDesc": "+{num} ${name} pour chaque ami que vous invitez",
    "DailyTasksDesc": "Complétez des tâches pour obtenir plus d'airdrop",
    "SponsorsandPartners": "Sponsors et partenaires",
    "Receivingwallet": "Portefeuille de réception",
    "Enterwalletaddress": "Entrez l'adresse de portefeuille {name}",
    "Claim": "Recevoir",
    "Booster": "Boosteur",
    "RentPeriod": "Période de location",
    "days30": "30 jours",
    "Dailyprofit": "Bénéfice quotidien",
    "Totalprofit": "Bénéfice total",
    "Quantity": "Quantité",
    "RentPrice": "Prix de location",
    "RentMiner": "Louer un mineur",
    "Insufficient": "Pensez à inviter assez de participants",
    "InsufficientMsg": "Vous devez inviter {num} amis pour gagner plus d'accessoires.",
    "Settings": "Paramètres",
    "copyid": "Copier l'ID",
    "UpgradeSuccessfully": "Mise à niveau réussie",
    "Name": "Nom",
    "userinfo": "Informations utilisateur",
    "disconnect": "Déconnexion",
    "Startmining": "Démarrer le minage",
    "Welcome": "Bienvenue à {name}",
    "Withdrawal": "Retrait",
    "Minimumamount": "Montant minimum",
    "Networkfee": "Frais de réseau",
    "Enteramount": "Entrer le montant",
    "Submit": "Soumettre",
    "MinimumTip": "Le montant du retrait est trop faible. Montant minimum de retrait : {num}",
    "MaximumTip": "Montant insuffisant, le montant maximum que vous pouvez retirer est : {num}",
    "SubmittedTip": "Soumis, traitement prévu dans un délai de 30 à 60 jours ouvrables",
    "WithdrawStatus": "Statut",
    "Submissiontime": "Heure de soumission",
    "WithdrawAwaitTip": "* Il est estimé que cela prendra 30 à 60 jours ouvrables. Inviter plus d'amis peut accélérer le processus de révision.",
    "Processing": "Traitement en cours",
    "Amount": "Montant",
    "Numberoffriends": "Nombre d'amis : {now}/{limit}",
    "InviteTip": "Pour compléter le processus de retrait, vous devez inviter {limit} amis à rejoindre l'application de minage.",
    "openonphone": "Ouvrez ce lien sur votre téléphone.",
    "claimTip": "Le montant à collecter est trop faible. Le montant minimum à collecter est : {num}",
    "WalletBalance": "Solde du portefeuille",
    "Withdraw": "Retirer",
    "SetWalletAddress": "Définir l'adresse du portefeuille",
    "WithdrawalRecord": "Historique des retraits",
    "Norecords": "Aucun enregistrement",
    "Whatis": "Qu'est-ce que {name} ?",
    "All": "Tous",
    "save": "Enregistrer",
    "successWithdrawal": "Numérisation réussie {num}",
    "secondsago": "{time} secondes ago",
    "Loading": "Chargement...",
    "PaymentConfirming": "Vérification de l'état de la transaction...",
    "Check": "Vérifier",
    "CheckFail": "La transaction n'est pas terminée. Veuillez vérifier à nouveau dans 5 secondes.",
    "Addname": "Ajoutez '{name}' à votre nom",
    "Restattcheck": "Redémarrez l'application pour vérifier",
    "Copyname": "Copier '{name}'",
    "SubmissionFailed": "Échec de la soumission, veuillez réessayer plus tard",
    "WithdrawalReview": "Révision du retrait",
    "WebWithdrawAwaitTip": "* Il est estimé que cela prendra 24 à 48 heures. Inviter plus d'amis peut accélérer le processus de révision.",
    "Success": "Succès",
    "Rejection": "Rejet",
    "WebSubmittedTip": "Soumis, nous le traiterons dès que possible.",
    "select_payment_method": "Sélectionner le mode de paiement",
    "total_amount": "Montant total",
    "next_step": "Prochain étape",
    "creating_order": "Création de la commande...",
    "order_created": "Commande créée",
    "order_status": "Statut de la commande",
    "order_id": "ID de la commande",
    "order_amount": "Montant de la commande",
    "order_status_desc": "Description de l'état de la commande",
    "payment_cancelled": "Paiement annulé",
    "opening_payment": "Ouverture du paiement...",
    "payment_success": "Paiement réussi",
    "payment_failed": "Paiement échoué",
    "payment_pending": "Paiement en attente",
    "payment_processing": "Paiement en cours",
    "create_order_failed": "Échec de la création de la commande",
    "creating_ton_order": "Création de la commande TON...",
    "check_payment_status": "Vérification de l'état du paiement...",
    "use_ton_payment": "Utiliser le paiement TON",
    "connect_wallet": "Connecter le portefeuille",
    "start_transaction": "Démarrer la transaction",
    "address": "Adresse",
    "amount_ton": "Montant TON",
    "copy": "Copier",
    "comment_memo": "Commentaire memo",
    "comment_memo_desc": "Veuillez entrer le commentaire memo",
    "comment_memo_placeholder": "Entrer le commentaire memo",
    "amount": "Montant",
    "wallet_address": "Adresse du portefeuille",
    "you_can_choose_to_connect_wallet_to_pay": "Vous pouvez choisir de connecter le portefeuille pour payer",
    "or_manually_transfer_to_the_above_address": "Ou transférer manuellement à l'adresse ci-dessus (notez que le montant et le memo doivent être exactement les mêmes)",
    "transaction_success": "Transaction réussie",
    "transaction_failed": "Échec de la transaction",
    "transaction_error": "Erreur de transaction",
    "transaction_status": "État de la transaction",
    "transaction_id": "ID de la transaction",
    "transaction_amount": "Montant de la transaction",
    "transaction_status_desc": "Description de l'état de la transaction",
    "miner_detail": "Détail du mineur",
    "rent_period": "Période de location",
    "days": "{days} jours",
    "daily_yield": "Rendement quotidien",
    "total_yield": "Rendement total",
    "invite_friends": "Inviter des amis",
    "price": "Prix",
    "rent": "Louer",
    "free_claim": "Récompense gratuite",
    "redeem": "Échanger",
    "buy": "Louer",
    "invite_friends_not_enough": "Pas assez d'amis invités",
    "redeem_success": "Échange réussi",
    "redeem_failed": "Échec de l'échange",
    "rent_success": "Location réussie",
    "rent_failed": "Échec de la location",
    "TotalPower": "Puissance totale",
    "MaxQuantity": "Valeur maximale atteinte",
    "Running": "En cours",
    "Stop": "Arrêter",
    "InviteTipFirst": "Pour effectuer votre premier retrait, vous devez inviter {limit} amis à rejoindre l'application de minage.",
    "Withdrawalunlock": "Déblocage de retrait",
    "Close": "Fermer",
    "Delivering": "Livraison",
    "Duetothelargenumber": "En raison du grand nombre de bénéficiaires, votre airdrop devrait arriver dans 15 à 20 jours ouvrables",
    "WithdrawalunlockTip": "Vous avez besoin de {num} amis invités pour compléter des tâches/lier des portefeuilles pour débloquer le retrait",
    "mining_title": "Robot",
    "Upgrade": "Mise à niveau",
    "partner": "Partenaire",
    "faq": "FAQ",
    "task": "Tâche",
    "OpenRobot": "Ouvrir Robot",
    "MyRobot": "Mon Robot",
    "Level": "Niveau",
    "Commission": "Commission",
    "DirectFriends": "Ami directs",
    "Feedback": "Retour d'expérience",
    "Pleaseenteryouremailaddress": "Veuillez saisir votre adresse e-mail",
    "Inputfeedbackcontent": "Entrer le contenu du retour d'expérience",
    "Submitfeedback": "Soumettre le retour d'expérience",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Retour d'expérience soumis avec succès, merci pour vos commentaires précieux",
    "Feedbacksubmissionfailed,pleaseretriy": "Échec de la soumission du retour d'expérience, veuillez réessayer",
    "Addressformaterror": "Erreur de format d'adresse",
    "Readclipboardfailed": "Échec de la lecture du presse-papiers",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Vous avez déjà soumis un retour d'expérience aujourd'hui, veuillez revenir demain",
    "Record": "Enregistrement",
    "Newuserguidance": "Voir la visite de bienvenue",
    "Usetonwallet": "Utiliser le portefeuille TON",
    "Reward": "Récompense",
    "Connectwallet": "Connecter le portefeuille",
    "Notconnected": "Non connecté",
    "Disconnect": "Déconnexion",
    "AboutTAI": "Détails du Token",
    "WithdrawalRecordDesc": "Historique de retrait",
    "StartAItrading": "Démarrer le trading AI",
    "Next": "Suivant",
    "Start": "Démarrer",
    "WithdrawalSuccess": "Retrait réussi",
    "WithdrawalFail": "Échec du retrait",
    "Max": "Max",
    "WithdrawalRecords": "Historique des retraits",
    "Commissionrules": "Règles de commission",
    "Mycommission": "Ma commission",
    "Shop": "Boutique",
    "BuyDifferentAIrobots": "Améliorez avec des appareils de calcul pour des scans plus rapides !",
    "CurrentRunningAIrobots": "Robots IA en cours d'exécution",
    "DailyProfit": "Bénéfice quotidien",
    "Buy": "Acheter",
    "ValidityPeriod": "Période de validité",
    "Days": "Jours",
    "Price": "Prix",
    "APY": "APY",
    "NoRobot": "Pas de puissance de calcul",
    "RemainingTime": "Temps restant",
    "InviteandEarn": "Invitez et gagnez",
    "InvitDec": "Invitez vos amis à rejoindre le trading IA et gagnez des commissions en USDT et des jetons d'airdrop ensemble !",
    "ShareToGroups": "Partager dans des groupes",
    "Select_payment_method": "Sélectionnez le mode de paiement",
    "twa_pay_tip_with_memo": "Veuillez vous assurer que l'adresse, le montant et la note sont cohérents pour le transfert.",
    "twa_pay_tip": "Veuillez vous assurer que l'adresse et le montant sont corrects pour le transfert.",
    "twa_pay_tip_placeholder": "Entrez le mémo de commentaire",
    "twa_pay_tip_placeholder_with_memo": "Entrez le mémo de commentaire avec mémo",
    "twa_pay_tip_placeholder_without_memo": "Entrez le mémo de commentaire sans mémo",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Entrez le mémo de commentaire avec mémo",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Entrez le mémo de commentaire sans mémo",
    "realtime_ai": "Trading IA en Temps Réel",
    "check_transaction_status": "Vérifier le statut de la transaction",
    "transaction_wait": "La transaction est en cours. Vous pouvez quitter l'application. Un message vous informera une fois qu'elle est terminée.",
    "Pleaseenteravalidemailaddress": "Veuillez entrer une adresse e-mail valide",
    "max_robot_tip": "Limite d'achat atteinte — essayez un autre plan pour continuer à trader !",
    "connectFailure": "Échec de la connexion du portefeuille",
    "connectSuccess": "Connexion du portefeuille réussie",
    "PayNow": "Payer maintenant",
    "min_withdrawal_amount": "Le montant minimum de retrait est de {num} {coin_name}",
    "max_withdrawal_amount": "Le montant maximum de retrait est de {num} {coin_name}",
    "balance_not_enough": "Vous n'avez pas assez de solde pour ce retrait.",
    "Numberofgroups": "Nombre de groupes : {now}/{limit}",
    "Withdraw_success": "Retrait réussi",
    "allProfit": "Bénéfice total",
    "AnnualProfit": "Bénéfice annuel",
    "ScanWallet": "Scanner le portefeuille",
    "wallet_check": "vérification_portefeuille",
    "Found": "Trouvé",
    "ScanSpeed": "Vitesse de scan",
    "MyComputingPower": "Calculer",
    "Scanning": "Analyse!",
    "WithdrawDetail": "Détails du retrait",
    "ScanSuccess": "Votre taux de réussite de scan a augmenté !",
    "TaskDescription": "Complétez des tâches pour augmenter votre taux de réussite de scan !",
    "InitializingMiningSystem": "Initialisation du système de scan...",
    "NoWithdrawalRecord": "Aucun enregistrement de retrait",
    "Invite": "Invitations requises",
    "Free": "Gratuit",
    "Confirm": "Confirmer",
    "RefreshTasks": "Rafraîchir les tâches",
    "NumberofGroups": "Nombre de groupes : {now}/{limit}",
    "SendMessage": "Envoyer un message",
    "NumberofShares": "Nombre de parts : {now}/{limit}",
    "NumberofTasks": "Nombre de tâches : {now}/{limit}",
    "CompleteTask": "Recevoir des récompenses",
    "Accelerated": "Accéléré",
    "Accelerated_withdrawals_success": "Retraits accélérés réussis",
    "GoBuy": "Allez acheter",
    "SpeedUpScan": "Accélérer",
    "Earnings": "Gains",
    "learnMore": "En savoir plus",
    "claimSuccess": "Récompenses collectées avec succès",
    "claimFailed": "Échec de la collecte, veuillez réessayer",
    "noDividends": "Aucun dividende à collecter",
    "dividendsInfoFallback": "Invitez des amis pour gagner des récompenses de parrainage"
}};